import React, { memo,useCallback, useContext, useMemo } from "react";
import { useNavigate } from "react-router";
import { BreadcrumbsContext } from "../../../core";
import { Button } from "../../Button";

import { ReactComponent as ArrowLeft } from "./icons/arrow-left.svg";

export const BackButton = memo(() => {
  const navigate = useNavigate();
  const breadcrumbs = useContext(BreadcrumbsContext);
  const previousNode = useMemo(
    () => [ ...breadcrumbs ].reverse()
      .find(x => !x.disabled && (x.to || x.href))
    , [ breadcrumbs ]);
  const onBackClick = useCallback(() => {
    if (previousNode?.to) {
      navigate(previousNode.to);
    } else if (previousNode?.href) {
      window.location.href = previousNode.href;
    }
  }, [ previousNode, navigate ]);
  
  if (!previousNode?.to && !previousNode?.href) {
    return null;
  }
  
  return (
    <Button
      type="button"
      onClick={onBackClick}
      buttonType="linkGray"
      buttonSize="md" 
      children={<><ArrowLeft /><span>Back</span></>}
    />
  );
});
